import { render, staticRenderFns } from "./BookingPerAirportTable.vue?vue&type=template&id=21a312e2"
import script from "./BookingPerAirportTable.vue?vue&type=script&lang=js"
export * from "./BookingPerAirportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports